/**
 * @flow
 * */

import React, { Component } from 'react'
import { ViuDownArrow } from '../../Icons/ViuDownArrow'

import {
  MainContainer,
  ReactSelect,
  CreatableReactSelect,
  ReactSelectError
} from './styledComponents'
import './react-select.scss'

type Props = {
  onChange: Function,
  validate: Function,
  className?: string,
  placeholder?: string,
  noResultsText?: string,
  value: any,
  occupationListDropDownValues: Array<Object>
}

class ReactSelectInput extends Component<Props> {
  static defaultProps = {
    noResultsText: 'No results found'
  }

  constructor(props) {
    super(props)
    this.state = {
      value: '',
      errorMsg: 'Error',
      displayError: false
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps
    const { value: currentValue } = this.props
    if (value !== currentValue) {
      this.setState({ value: value || '' })
    }
  }

  arrowRenderer = () => <ViuDownArrow />

  logChange = value => {
    const { onChange } = this.props
    this.setState({ displayError: false, errorMsg: 'Error', value }, () =>
      onChange(this.state.value)
    )
  }

  setError = error => {
    this.setState({ errorMsg: error })
  }
  setDisplayError = displayError => {
    this.setState({ displayError })
  }

  validate = () => {
    const { validate } = this.props
    let response
    if (validate) {
      response = validate(this.state.value)
      if (response.displayError) {
        this.setError(response.errorMsg)
      }
      this.setDisplayError(response.displayError)
    }
    return response
  }

  getFormValues = (value, occupationDropDownWithStyle, style) => {
    const newOption = {
      label: value,
      value,
      style
    }
    const isPresent = newValue =>
      occupationDropDownWithStyle.some(el => el.label === newValue)
    if (!isPresent(value) && value !== '') {
      return occupationDropDownWithStyle.concat(newOption)
    } else {
      return occupationDropDownWithStyle
    }
  }

  render() {
    const style = {
      fontFamily: 'din-2014',
      fontSize: '14px',
      fontWeight: 'normal',
      fontStyle: 'normal'
    }

    const { value, displayError, errorMsg } = this.state
    const {
      placeholder,
      noResultsText,
      className,
      occupationListDropDownValues,
      isCreatable
    } = this.props

    const occupationDropDownWithStyle = occupationListDropDownValues.map(
      occupationObject => ({
        ...occupationObject,
        style
      })
    )

    return (
      <MainContainer>
        {isCreatable ? (
          <CreatableReactSelect
            options={this.getFormValues(
              value,
              occupationDropDownWithStyle,
              style
            )}
            clearable={false}
            simpleValue
            value={this.state.value}
            onChange={this.logChange}
            placeholder={placeholder}
            className={className}
            arrowRenderer={this.arrowRenderer}
            displayError={displayError}
            noResultsText={noResultsText}
          />
        ) : (
          <ReactSelect
            options={this.getFormValues(
              value,
              occupationDropDownWithStyle,
              style
            )}
            clearable={false}
            simpleValue
            value={this.state.value}
            onChange={this.logChange}
            placeholder={placeholder}
            className={className}
            arrowRenderer={this.arrowRenderer}
            displayError={displayError}
            noResultsText={noResultsText}
          />
        )}

        <ReactSelectError displayError={displayError}>
          {errorMsg}
        </ReactSelectError>
      </MainContainer>
    )
  }
}

export default ReactSelectInput



// WEBPACK FOOTER //
// ./src/commons/ReactSelectInput/index.js